import React, { Component } from "react";
import { Button } from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faGripVertical,
} from "@fortawesome/free-solid-svg-icons";

import widgetRegistry from "./config/widgetRegistry";
import AuthContext from "../../context/AuthContext";

export default class DashboardCustomizer extends Component {
  static contextType = AuthContext;

  getAllWidgets() {
    const { layout } = this.props;
    const t = Number(this.context.type);
    const r = Number(this.context.role);

    return [...layout]
      .sort((a, b) => a.position - b.position)
      .filter((w) => {
        const meta = widgetRegistry[w.widgetId];
        return (
          meta &&
          meta.allowedTypes.includes(t) &&
          meta.allowedRoles.includes(r)
        );
      });
  }

  render() {
    const { onToggleVisibility, onReset, onClose } = this.props;
    const allWidgets = this.getAllWidgets();

    return (
      <>
        {/* Backdrop */}
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.15)",
            zIndex: 999,
          }}
          onClick={onClose}
        />
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            width: "320px",
            height: "100vh",
            backgroundColor: "#fff",
            boxShadow: "-4px 0 12px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            padding: "24px 20px",
            overflowY: "auto",
          }}
        >
          <h3 style={{ margin: "0 0 4px 0", fontSize: "16px", fontWeight: 600 }}>
            Personnalisation
          </h3>
          <p style={{ margin: "0 0 20px 0", fontSize: "13px", color: "#888" }}>
            Réorganisez les widgets par glisser-déposer sur le tableau de bord.
            Activez ou désactivez leur visibilité ci-dessous.
          </p>

          <h4
            style={{
              margin: "0 0 10px 0",
              fontSize: "12px",
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              color: "#999",
            }}
          >
            Widgets
          </h4>

          <div style={{ flex: 1, overflowY: "auto", marginBottom: "16px" }}>
            {allWidgets.map((w) => {
              const meta = widgetRegistry[w.widgetId];
              return (
                <div
                  key={w.widgetId}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "10px 12px",
                    marginBottom: "6px",
                    backgroundColor: w.visible ? "#f0f7ff" : "#f5f5f5",
                    borderRadius: "6px",
                    fontSize: "13px",
                    border: w.visible
                      ? "1px solid #d0e3f7"
                      : "1px solid #e8e8e8",
                    transition: "all 0.2s",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faGripVertical}
                    style={{ color: "#ccc", fontSize: "11px" }}
                  />
                  <span
                    style={{
                      flex: 1,
                      color: w.visible ? "#333" : "#aaa",
                      fontWeight: w.visible ? 500 : 400,
                    }}
                  >
                    {meta ? meta.title : w.widgetId}
                  </span>
                  <span
                    style={{
                      cursor: "pointer",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      color: w.visible ? "#026fc2" : "#999",
                      backgroundColor: w.visible
                        ? "rgba(2, 111, 194, 0.1)"
                        : "transparent",
                      transition: "all 0.2s",
                    }}
                    onClick={() => onToggleVisibility(w.widgetId)}
                    title={w.visible ? "Masquer" : "Afficher"}
                  >
                    <FontAwesomeIcon
                      icon={w.visible ? faEye : faEyeSlash}
                    />
                  </span>
                </div>
              );
            })}
          </div>

          <div style={{ display: "flex", gap: "8px" }}>
            <Button
              text="Réinitialiser"
              className="bg-orange"
              onClick={onReset}
            />
            <Button text="Terminer" className="bg-blue" onClick={onClose} />
          </div>
        </div>
      </>
    );
  }
}
